import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { renderField, renderCheckbox, required } from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Modal, ModalHeader, ModalBody, ModalFooter, Table, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getApiConfigs} from "../../../actions/actionDevloper";
import { getLicenseStatus} from "../../../actions/actionFooter";

class ApiFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentApi: {},
            apiModal: false,
            licensed: false
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.toggleApiModal = this.toggleApiModal.bind(this);
        this.closeApiModal = this.closeApiModal.bind(this);
    }

    submitApi(userData) {
        if (!userData.enabled) {
            userData.enabled = false;
        }
        if (!userData.read_only) {
            userData.read_only = false;
        }
        if (this.props.fromUpdate) {
            userData.api_id = this.state.currentApi && this.state.currentApi.api_id;
            this.props.updateApi(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createApi({api_config: userData})
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    toggleApiModal(){
        this.setState({apiModal: !this.state.apiModal});
    }
    closeApiModal(){
        this.props.history.push("/developers");
    }

    handleUpdateSuccess(){
        const {updateApiError} = this.props;
        if(updateApiError){
            NotificationManager.error(updateApiError,"Create Api", 3000);
        }
        else{
            NotificationManager.success("API Created", "Successfully Created Api");
            this.props.history.push("/developers");
        }
    }

    handleUpdateError(){
        const {updateApiError} = this.props;
        if(updateApiError){
            NotificationManager.error(updateApiError,"Create Api", 3000);
        } else
            NotificationManager.error("Create API Failed","Create Api", 3000);
    }

    handleCreateSuccess(){
        const {createApiError} = this.props;
        if(createApiError){
            NotificationManager.error(createApiError,"Create Api", 3000);
        }
        else{
            NotificationManager.success("API Created", "Successfully Created Api");
            this.toggleApiModal();
        }
    }

    handleCreateError(){
        const {createApiError} = this.props;
        if(createApiError){
            NotificationManager.error(createApiError,"Create Api", 3000);
        } else
            NotificationManager.error("Create API Failed","Create Api", 3000);
    }

    cancelButton(){
        this.props.history.push("/developers");
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.apis && nextProps.apis.length > 0 && this.props.apis !== nextProps.apis && this.props.getAPILoading && this.props.fromUpdate){
            let currentApi = nextProps.apis.find(api => api.api_id === this.props.apiId);
            this.setState({currentApi: currentApi});
            this.props.initialize({
                name: currentApi.name,
                enabled: currentApi.enabled,
                read_only: currentApi.read_only,

            });
        }
    }

    componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getApiConfigs();
        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('developer_api') >= 0 ){
                    this.setState({licensed: true});
                }
            });
    }


    render() {
        const {handleSubmit} = this.props;
        const {checked} = this.state;
        if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }

        return (
        <div>
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="name"
                                       id="name"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="enabled" className="pull-left">Enabled &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="enabled">
                                    <Field name="enabled"
                                           id="enabled"
                                           checked = {checked}
                                           type ="checkbox"
                                           component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="read_only" className="pull-left">Read Only &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="read_only">
                                    <Field name="read_only"
                                           id="read_only"
                                           checked = {checked}
                                           type ="checkbox"
                                           component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm" 
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit" size="sm"
                        className="submit-button" 
                        color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
            <Modal isOpen={this.state.apiModal} className={`user-modal`}>
                <ModalHeader toggle={this.closeApiModal}>API Key</ModalHeader>
                <ModalBody>
                    <div>
                        <Row><Col>Please save the security credentials. This is the only time the secret key will be visible.</Col></Row>
                        &nbsp;
                        &nbsp;
                        <Table>
                            <tbody>
                                <tr><td><strong>API KEY: </strong></td><td>{this.props.createdApi ? this.props.createdApi.api_key : ""}</td></tr>
                                <tr><td><strong>API KEY SECRET: </strong></td><td>{this.props.createdApi ? this.props.createdApi.api_key_secret : ""}</td></tr>
                            </tbody>
                        </Table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.closeApiModal} size="sm"
                    className="cancel-button"
                    color="basic"> Close</Button>
                </ModalFooter>
            </Modal>
        </div>
        );
    }
}

ApiFormTemplate.proptypes = {
    createApi: Proptypes.func,
    updateApi: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let ApiFormWithRouter = withRouter(ApiFormTemplate);


let ApiForm =  connect(state =>
        ({
            createApiError: state.develop.createApiError,
            createAPILoading: state.develop.createAPILoading,
            createdApi: state.develop.createdApi,
            updateApiError: state.develop.updateApiError,
            updateAPILoading: state.develop.updateAPILoading,
            updatedApi: state.develop.updatedApi,
            apis: state.develop.apis,
            getAPILoading: state.develop.getAPILoading || false,
            license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
        }),
    dispatch =>
        ({
            getApiConfigs: () => dispatch(getApiConfigs()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        }))(ApiFormWithRouter);

export default reduxForm({
    form: "ApiForm",
})(ApiForm);


// WEBPACK FOOTER //
// ./src/views/Developers/ApiForm/ApiForm.js